import { render, staticRenderFns } from "./BookhousecafeView.vue?vue&type=template&id=d3c625c2&scoped=true&"
import script from "./BookhousecafeView.vue?vue&type=script&lang=js&"
export * from "./BookhousecafeView.vue?vue&type=script&lang=js&"
import style0 from "./BookhousecafeView.vue?vue&type=style&index=0&id=d3c625c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c625c2",
  null
  
)

export default component.exports